import { j as s } from "./jsx-runtime.DGlMoOmv.js";
import { c as i } from "./index.CxSWpsOB.js";
import { T as p } from "./Text.BGhoO_e3.js";
import { c as _ } from "./index.C4-GUKyp.js";
import { n as T, M as w, a as y, I } from "./MediaTile.DaLJeauY.js";
const O = 56, P = {
  md: "md",
  lg: "lg"
}, E = {
  sm: "body-1-m",
  md: "body-2-m",
  lg: "headline-1-m"
}, z = "body-1", L = ({
  className: t,
  children: e
}) => /* @__PURE__ */ s.jsx("div", { "data-slot": "item-v2-actions", className: i("tw-inline-flex tw-w-max tw-max-w-full tw-shrink-0 tw-flex-nowrap tw-items-center tw-justify-start tw-gap-0 [&>*]:tw-flex-none", t), children: e }), h = "tw-flex tw-flex-1 tw-min-w-0 tw-flex-col [&+[data-slot=item-v2-content]]:tw-flex-none", j = {
  sm: "tw-gap-2",
  md: "tw-gap-2",
  lg: "tw-gap-4"
}, k = ({
  className: t,
  contentSize: e,
  children: o
}) => {
  const a = e ?? "md";
  return /* @__PURE__ */ s.jsx("div", { "data-slot": "item-v2-content", "data-content-size": a, className: i(h, j[a], t), children: o });
}, F = ({
  className: t,
  contentSize: e,
  children: o,
  testId: a,
  variant: n = "primary"
}) => {
  const d = e ?? "md";
  return /* @__PURE__ */ s.jsx(p, { element: "p", typeface: z, "data-slot": n === "secondary" ? "item-v2-secondary-description" : "item-v2-description", "data-content-size": d, testId: a, className: i("tw-m-0 tw-line-clamp-2 tw-text-balance [&>a:hover]:tw-text-primary [&>a]:tw-underline [&>a]:tw-underline-offset-4", n === "secondary" ? "tw-text-gray-600" : "tw-text-gray-900", t), children: o });
}, X = ({
  className: t,
  children: e
}) => /* @__PURE__ */ s.jsx("div", { "data-slot": "item-v2-footer", className: i("tw-flex tw-basis-full tw-items-center tw-justify-between tw-gap-2", t), children: e }), Y = ({
  className: t,
  children: e
}) => /* @__PURE__ */ s.jsx("div", { "data-slot": "item-v2-header", className: i("tw-flex tw-basis-full tw-items-center tw-justify-between tw-gap-2", t), children: e }), Z = ({
  className: t,
  children: e
}) => /* @__PURE__ */ s.jsx("div", { "data-slot": "item-v2-main", className: i("tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-32", t), children: e }), S = _(["tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-4", "tw-group-has-[[data-slot=item-v2-description]]/item-v2:translate-y-0.5 tw-group-has-[[data-slot=item-v2-description]]/item-v2:self-start", "tw-group-has-[[data-slot=item-v2-secondary-description]]/item-v2:translate-y-0.5 tw-group-has-[[data-slot=item-v2-secondary-description]]/item-v2:self-start", "[&_svg]:tw-pointer-events-none [&_img]:tw-size-full [&_img]:tw-object-cover"].join(" "), {
  variants: {
    variant: {
      default: "tw-bg-transparent",
      icon: "tw-bg-transparent",
      image: "",
      avatar: "tw-rounded-circular"
    },
    size: {
      24: "tw-size-24",
      40: "tw-size-40",
      56: "tw-size-56"
    }
  },
  defaultVariants: {
    variant: "default",
    size: 40
  }
}), M = "tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-group-has-[[data-slot=item-v2-description]]/item-v2:translate-y-0.5 tw-group-has-[[data-slot=item-v2-description]]/item-v2:self-start tw-group-has-[[data-slot=item-v2-secondary-description]]/item-v2:translate-y-0.5 tw-group-has-[[data-slot=item-v2-secondary-description]]/item-v2:self-start", G = ({
  alt: t = "",
  avatar: e,
  avatarAlt: o = "",
  children: a,
  className: n,
  media: d,
  size: f,
  variant: r = "default"
}) => {
  const l = f ?? 40, m = T(d), v = m != null || r === "icon" && a != null ? i(M, n) : i(S({
    variant: r,
    size: l,
    className: n
  })), u = e?.trim() || void 0;
  let c;
  if (m != null) {
    const x = m.length === 1 ? m[0] : m, g = l === 24 ? 40 : l;
    c = /* @__PURE__ */ s.jsx(w, { alt: t, avatar: u, avatarAlt: o, media: x, size: y[g] });
  } else r === "icon" && a != null ? c = /* @__PURE__ */ s.jsx(w, { icon: a, size: I[l], className: "tw-bg-transparent" }) : c = r === "default" ? a : null;
  return /* @__PURE__ */ s.jsx("div", { "data-slot": "item-v2-media", "data-variant": r, "data-size": l, className: v, children: c });
}, H = ({
  className: t
}) => /* @__PURE__ */ s.jsx("div", { "data-slot": "item-v2-separator", role: "separator", className: i("tw-shrink-0 tw-border-t tw-border-gray-200", t) }), R = ({
  className: t,
  contentSize: e,
  children: o,
  testId: a
}) => {
  const n = e ?? "md";
  return /* @__PURE__ */ s.jsx(p, { element: "div", typeface: E[n], "data-slot": "item-v2-title", "data-content-size": n, testId: a, className: i("tw-flex tw-w-fit tw-items-center tw-gap-2 tw-text-gray-900", n !== "md" && "tw-font-semibold tw-leading-snug", t), children: o });
};
export {
  O as D,
  L as I,
  k as a,
  F as b,
  X as c,
  Y as d,
  Z as e,
  G as f,
  H as g,
  R as h,
  P as i,
  E as j,
  z as k
};
//# sourceMappingURL=ItemV2Title.R5KRywzn.js.map
